import { render, staticRenderFns } from "./OrderItemCard.vue?vue&type=template&id=28582c9a&"
import script from "./OrderItemCard.vue?vue&type=script&lang=js&"
export * from "./OrderItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports